module.exports = __webpack_public_path__ + "img/direction_right_hover.449a4aa8.svg";